import log2sensors, { SensorsEventIds } from "@/utils/log2sensors";
import { useTranslation } from "next-i18next";
import React, { useEffect, useState } from "react";
import SurveyTitle from "../SurveyTitleV2";
import SurveyFooter from "../SurveyFooter";
import Toast from "@/components/Toast";
import { HasNonMainlandBankCardEnum } from "@/interfaces/enums";
import { saveHasNonMainlandBankCard } from "@/hooks/useRequest/useSurveyRequest";
import log2Sentry from "@/utils/log2Sentry";

import SelectOptions from "@/components/SelectOptions";
import ContentContainer from "@/containers/common/ContentContainer";

interface MainlandBankCardProps {
	hasNonMainlandBankCard?: HasNonMainlandBankCardEnum;
	onNextClick: () => void;
}
function MainlandBankCard(props: MainlandBankCardProps) {
	const { t } = useTranslation("survey");
	const [loading, setLoading] = useState(false);
	const [hasBankCardStatus, sethHsBankCardStatus] = useState<number>();

	useEffect(() => {
		if (props.hasNonMainlandBankCard) {
			sethHsBankCardStatus(props.hasNonMainlandBankCard);
		}
	}, [props.hasNonMainlandBankCard]);

	const options = [
		{
			label: t("yes", { ns: "common" }),
			value: HasNonMainlandBankCardEnum.HAS,
		},
		{
			label: t("no", { ns: "common" }),
			value: HasNonMainlandBankCardEnum.DOES_NOT_HAVE,
		},
	];

	const handleSubmit = async (_val: number) => {
		if (_val === undefined) {
			Toast.info(t("please-select-where-your-account-is-issued"));
			return;
		}

		try {
			await saveHasNonMainlandBankCard(_val);
			props.onNextClick();
		} catch (error: any) {
			console.log(error);
			log2Sentry(error.message, "error", error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		log2sensors(SensorsEventIds.BAO_OVERSEA_ACC_VIEW);
	}, []);

	return (
		<ContentContainer
			animation
			header={
				<div className="px-4.5">
					<SurveyTitle title={t("do-you-have-a-bank-account-issued-outside-of-mainland-china")} />
				</div>
			}
			footer={
				<div className="px-4.5">
					<SurveyFooter nextBtn={false} />
				</div>
			}
		>
			<div className="h-12" />
			<SelectOptions
				value={hasBankCardStatus}
				options={options}
				loading={loading}
				onChange={(value) => {
					sethHsBankCardStatus(Number(value));
					switch (value) {
						case HasNonMainlandBankCardEnum.HAS:
							log2sensors(SensorsEventIds.BAO_OVERSEA_ACC_Y);
							break;
						case HasNonMainlandBankCardEnum.DOES_NOT_HAVE:
							log2sensors(SensorsEventIds.BAO_OVERSEA_ACC_N);
							break;
						default:
							break;
					}
					handleSubmit(Number(value));
				}}
			/>
		</ContentContainer>
	);
}

export default MainlandBankCard;
